import React, { useRef, useEffect, useState, useContext } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import IconPDF from '../../midia/icon_pdf.svg';

// COMPONENTES---------
import { SetFunctions } from '../../componentes/Functions';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';


//----------------------------------------------------
export function Add_Arquivos({ permitirExcluirArquivosSalvos = true } = {}) {
    const { state, dispatch } = useContext(Context);
    const { evento } = state.evento;
    const {logado} = state.cliente;
    
    const UploadRef = useRef(null);

    const [arrayFiles, setarrayFiles] = useState([]);
    const [arrayImag, setarrayImag] = useState([]);
    const { SetListaPesquisa } = SetFunctions();
    const { DeleteArquivo_S3 } = ApiEvento();
    

    // ----------------------------------
    function SelectFile() {
        if (UploadRef.current) {
            UploadRef.current.click();
        }
    };

    // -----------------------------------
    function ehAudio(arquivo) {
        const tipo = typeof arquivo === 'object' ? arquivo.type : '';
        const nome = typeof arquivo === 'object' ? arquivo.name : arquivo;
        return /audio\//i.test(tipo) || /application\/ogg/i.test(tipo) || /\.(opus|ogg|oga|m4a|mp3|aac|amr|wav)$/i.test(nome || '');
    }

    function AddFile(files) {
        const arquivosAceitos = [];
        const imagensAceitas = [];
        let arquivoGrande = false;
        let arquivoNaoSuportado = false;

        Array.from(files || []).forEach(file => {
            const suportado = /image/i.test(file.type) || file.type === 'application/pdf' || ehAudio(file);

            if (!suportado) {
                arquivoNaoSuportado = true;
            } else if (file.size > 10000000) {
                arquivoGrande = true;
            } else {
                arquivosAceitos.push(file);
                imagensAceitas.push({ fileUrl: URL.createObjectURL(file), nome: file.name, type: file.type });
            }
        });

        if (arquivosAceitos.length > 0) {
            setarrayFiles(atuais => [...atuais, ...arquivosAceitos]);
            setarrayImag(atuais => [...imagensAceitas.reverse(), ...atuais]);
        }
        if (arquivoGrande) alert('ERRO: Arquivo muito grande! max. 10MB');
        if (arquivoNaoSuportado) alert('ERRO: Arquivo não suportado. Selecione imagem, PDF ou áudio.');
    };

    // -----------------------------------
    useEffect(() => {
        SetListaPesquisa("listaArquivos", arrayFiles);
    }, [arrayFiles]);

    // ----------------------------------
    function Delete(t) {
        const xx = arrayImag.filter(e => e.fileUrl !== t.fileUrl);
        setarrayImag(xx);

        const yy = arrayFiles.filter(e => e.name !== t.nome);
        setarrayFiles(yy);
    };

    // ---------------------

    useEffect(() => {
        setarrayImag([]);
        setarrayFiles([]);
    }, [evento.arquivos]);

    // --------------------
    const [tipoArquivo, setTipoArquivo] = useState('');
    const [arquivoSelecionado, setArquivoSelecionado] = useState(null);

    // Função para abrir arquivo em tela cheia
    const abrirArquivo = (arquivo) => {      
        // Verificar se é vídeo
        if (/\.mp4$/i.test(arquivo) || /video/i.test(arquivo)) {
            setTipoArquivo('video');
        } else {
            setTipoArquivo('imagem');
        }
        
        setArquivoSelecionado(arquivo);
    };

    // Função para fechar visualização
    const fecharVisualizacao = () => {
        setArquivoSelecionado(null);
        setTipoArquivo('');
    };

    // ----------------------------------
    function AddArquivos({ apenasArquivosPagamento = false } = {}) {
        const arquivosSalvos = apenasArquivosPagamento
            ? evento.arquivos.filter(arquivo => /pagamento/i.test(arquivo)) : evento.arquivos;

        // =============
        return (
            <S.Arquivos ListaArquivos={arquivosSalvos.length > 0 || arrayImag.length > 0}>
                <input
                ref={UploadRef}
                type='file'
                multiple
                onChange={(e) => {
                    AddFile(e.target.files);
                    e.target.value = '';
                }}
                style={{ display: "none" }}
                accept='image/*, application/pdf, audio/*, application/ogg, .opus, .ogg, .oga, .m4a, .mp3, .aac, .amr, .wav'
                />

                {arrayImag.length > 0 &&
                <div style={{ display: "flex", margin: "5px 0", gap: "4px", flexWrap: "wrap" }}>
                    {arrayImag.map((t, k) => (
                        <div key={k} style={{ display: "flex", position: "relative", alignItems: "center" }}>
                            {t.type === "application/pdf" &&
                                <div style={{ display: "flex", width: "60px", height: "80px", backgroundColor: "white", alignItems: "center", justifyContent: "center" }}>
                                    <img src={IconPDF} style={{ display: "flex", width: "50%" }} />
                                </div>
                            }
                            
                            { /image/i.test(t.type) && 
                            <img 
                            src={t.fileUrl} 
                            style={{ margin: "3px 0", width: "80px", height: "80px" }} 
                            /> 
                            }

                            {ehAudio(t) &&
                                <audio src={t.fileUrl} controls style={{ width: "220px" }} />
                            }
                            
                            <div
                            className='fechar'
                            onClick={() => Delete(t)}
                            >
                                X
                            </div>
                        </div>
                    ))}
                </div>
                }

                {arquivosSalvos.length > 0 &&
                <div style={{ display: "flex", margin: "5px 0", gap: "4px", flexWrap: "wrap" }}>
                    {arquivosSalvos.map((t, k) => (
                        <div key={k} style={{ display: "flex", position: "relative", alignItems: "center", gap: "10px" }}>
                            {
                            ehAudio(t) ?
                            <audio
                            src={`https://rbento-web.s3.us-east-1.amazonaws.com/${t}`}
                            controls
                            style={{ width: "220px" }}
                            />
                            :

                            /pdf/i.test(t) ?
                            <div 
                            style={{ display: "flex", width: "60px", height: "80px", backgroundColor: "white", alignItems: "center", justifyContent: "center" }}
                            onClick={() => window.open(`https://rbento-web.s3.us-east-1.amazonaws.com/${t}`)}
                            >
                                <img src={IconPDF} style={{ display: "flex", width: "50%" }} />
                            </div>

                            :

                            <img 
                            src={`https://rbento-web.s3.us-east-1.amazonaws.com/${t}`} 
                            style={{ margin: "3px 0", width: "80px", height: "80px" }} 
                            onClick={() => abrirArquivo(`https://rbento-web.s3.us-east-1.amazonaws.com/${t}`)}/>
                            }
                            
                            {permitirExcluirArquivosSalvos && evento.status !== "C" && (logado.nivel === "master" || logado.nivel === "admin") &&
                            <button
                            type="button"
                            className='fechar'
                            aria-label={`Excluir arquivo ${t}`}
                            onPointerDown={(event) => event.stopPropagation()}
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                DeleteArquivo_S3(t);
                            }}
                            >
                                X
                            </button>
                            }
                        </div>
                    ))}
                </div>
                }
                {/* Modal de visualização em tela cheia */}
                {arquivoSelecionado && (
                <S.Play>
                    <S.BoxPlay>
                        {tipoArquivo === 'video' ? (
                            <video
                                src={arquivoSelecionado}
                                controls
                                autoPlay
                                style={{
                                    maxWidth: "90vw",
                                    maxHeight: "80vh",
                                    borderRadius: "10px"
                                }}
                            />
                        ) : (
                            <img
                                src={arquivoSelecionado}
                                alt="Visualização"
                                style={{
                                    width: "75vw",
                                    height: "75vh",
                                    borderRadius: "10px",
                                    objectFit: "contain"
                                }}
                            />
                        )}
                        
                        <button
                            onClick={fecharVisualizacao}
                            style={{
                                marginTop: "20px",
                                padding: "10px 30px",
                                fontSize: "16px",
                                fontWeight: "bold",
                                backgroundColor: "#f0433d",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer"
                            }}
                        >
                            X FECHAR
                        </button>
                    </S.BoxPlay>
                </S.Play>
                )}
            </S.Arquivos>
        )
    };

    // ####################################################
    return { SelectFile, AddArquivos }
}